module.exports = __webpack_public_path__ + "mp3/Down_with_Paradise.mp3";